import shape1 from "../../images/shape/circle-shape1.png"
import SectionTitle from "../common/SectionTitle"
import ProcessCard from "../common/ProcessCard"
import { getBackgroundClass } from "../../utils/sectionHelpers";

const ProcessBox = ({data}) => {
      const settings = data?.Settings || {};
    
      const backgroundClass = getBackgroundClass(settings.background);
  return (
    <>
      <section className={`process-area pt-100 pb-70 ${backgroundClass}`}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9" data-aos="fade-right" data-aos-duration="1200">
              <SectionTitle data={data} />
            </div>
          </div>

          {/* <div className="row gy-3 justify-content-center">
            <div className="col-lg-4 col-md-6" data-aos="fade-right" data-aos-duration="1200">
              <div className="single-process-box">
                <div className="number">1</div>
                <div className="image">
                  <img src={process1} alt="banner" />
                </div>
                <h3>Discovery & Planning</h3>
                <p>
                  We begin by understanding your business goals, target audience, competitor landscape, and required features, defining a solid project roadmap.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-duration="1200">
              <div className="single-process-box">
                <div className="number">2</div>
                <div className="image">
                  <img src={process2} alt="banner" />
                </div>
                <h3>Wireframes & UX Structure</h3>
                <p>
                  We map user journeys, navigation flow, and page structure to ensure a smooth and intuitive experience before moving into design.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6" data-aos="fade-left" data-aos-duration="1200">
              <div className="single-process-box">
                <div className="number">3</div>
                <div className="image">
                  <img src={process3} alt="banner" />
                </div>
                <h3>UI Design & Branding</h3>
                <p>
                  Our designers craft visually compelling interfaces aligned with your brand identity, focusing on clarity, emotion, and engagement.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6" data-aos="fade-right" data-aos-duration="1200">
              <div className="single-process-box ">
                <div className="number">4</div>
                <div className="image">
                  <img src={process4} alt="banner" />
                </div>
                <h3>Development & System Integration</h3>
                <p>
                  Our development team transforms designs into fully functional, secure, high-performance websites with CRM, API, or custom integrations where needed.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-duration="1200">
              <div className="single-process-box">
                <div className="number">5</div>
                <div className="image">
                  <img src={process5} alt="banner" />
                </div>
                <h3>Content & SEO Optimization</h3>
                <p>
                  We optimize structure, metadata, content placement, mobile responsiveness, and speed — ensuring Google and users love your website.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6" data-aos="fade-left" data-aos-duration="1200">
              <div className="single-process-box">
                <div className="number">6</div>
                <div className="image">
                  <img src={process6} alt="banner" />
                </div>
                <h3>Testing & Launch</h3>
                <p>
                  The website undergoes rigorous QA, bug fixing, cross-device/browser checks, security review, and accessibility compliance before launch.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-duration="1200">
              <div className="single-process-box">
                <div className="number">7</div>
                <div className="image">
                  <img src={process1} alt="banner" />
                </div>
                <h3>Post-Launch Support & Improvements</h3>
                <p>
                  We provide continuous monitoring, performance optimization, analytics insights, and feature upgrades to support ongoing growth.
                </p>
              </div>
            </div>
          </div> */}
          <ProcessCard  data={data} />
        </div>

        <div className="circle-shape1">
          <img src={shape1} alt="banner" />
        </div>
      </section>
    </>
  )
}

export default ProcessBox
